module.exports = __webpack_public_path__ + "static/media/sample_share_of_business.87094d00.csv";